import axiosOpenClient from "./axiosOpenClient";

/**
 * Send a bug report to the API with optional attachment
 * @param formData - FormData containing email, name, message, and optional attachment
 */
export const reportBug = async (formData: FormData) => {
  try {
    // Use FormData directly without stringifying for multipart/form-data support
    const response = await axiosOpenClient.post(
      "/public/api/report-bug",
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}